import React from 'react'
import {useParams} from 'react-router-dom'
import { CartState } from "../../context/Context";

import ProductInfo from '../../components/Primary/ProductInfo'
import MainLayout from '../../Layout/MainLayout'
import ReviewForm from '../../components/Primary/ReviewForm'
import ProductCard from '../../components/Primary/ProductCard'


const ProductDetail = () => {
    const {id} = useParams()
    const {
        state: { products,cart },
       
      } = CartState();
    const product = products.find(product => product.id === id)
      const {name, price, image, description} = product;

      const similar = products.slice(0,4);
      const findQty = id => {
        const item = cart.find(item => item.id === id);
        if(item){
          return item.qty
        }
        return null
      }
      

  return (
    <MainLayout>
    <div className="bg-gray-light h-full w-full 2xl:container 2xl:mx-auto ">
      <div className="w-full  md:px-2 lg:px-10 mb-8 lg:mb-10">
        <div className="flex flex-col md:flex-row justify-between  h-auto pt-8 space-x-4  ">
          {/* Start of the left side */}
          <div className="h-left sm:w-6/12 ">
          <div className="flex md:space-x-8 h-auto md:justify-between md:flex-row flex-col-reverse  ">
             <div className=" hidden md:w-3/12 w-full md:flex flex-col  mr-4  space-y-2">
                    <div className="flex justify-center  align-center">
                        <img src={image} alt="product" className="w-full h-full"/>
                    </div>
                    <div className="flex justify-center align-center">
                        <img src={image} alt="product" className="w-full h-full"/>
                    </div>
                    <div className="flex justify-center align-center">
                        <img src={image} alt="product" className="w-full h-full"/>
                    </div>
                 </div>    
                 <div className="md:w-9/12 w-full h-full">   
                 <div className="flex w-full align-center ">
            <img src={image} alt="product" className="lg:w-full  "/>
            </div>
            </div>
            </div>

      </div>
      {/* end og the left side */}
      <div className="h-right sm:w-6/12 h-full">
     <ProductInfo name={name} price={price} description={description}/>
      </div>
      </div>
      </div>
      <ReviewForm />
      <div className="mt-8 md:mt-20 mb-4">
          
             <h1 className="font-poppins font-bold text-large" >
     Related Products
     </h1>
     <div className="underline" />
          </div>
            {/* Product cards */}
            <div className="flex md:flex-wrap  flex-col md:flex-row justify-center lg:justify-start mt-4 md:mt-8">
        {
          similar.map((prod) => {
          
            return (
              <ProductCard  key={prod.id} prod={prod} qty={findQty(prod.id)} />
            )
          })
        }
          
        
          </div>
          {/* End of Product Card */}
      </div>
        </MainLayout>
  )
}

export default ProductDetail